<template>
  <div class="wrap">
    <div class="wrap-top">
      <div class="top-main">
        <div class="main-item" >
          <p class="top">培训总数
            <img style="display: inline-block;float: right;" src="@/assets/img/ts1.png" alt=""></p>
          <p class="bottom">
            <span style="color:#81B337">{{form.training_total }}</span>
            <span>次</span></p>
        </div>
        <div class="main-item" >
          <p class="top">考试总数 <img style="display: inline-block;float: right;" src="@/assets/img/ts2.png" alt=""></p>
          <p class="bottom">
            <span style="color:#54BCBD">{{form.exam_total }}</span>
            <span>次</span></p>
        </div>
        <div class="main-item" >
          <p class="top">考试人次总数 <img style="display: inline-block;float: right;" src="@/assets/img/ts3.png" alt=""></p>
          <p class="bottom">
            <span style="color:#9B7D31">{{form.exam_user_log_total }}</span>
            <span>人次</span></p>
        </div>
        <div class="main-item"  >
          <p class="top">考试合格总数 <img style="display: inline-block;float: right;" src="@/assets/img/ts4.png" alt=""></p>
          <p class="bottom">
            <span style="color:#377F7F">{{form.exam_pass_total }}</span>
            <span>人次</span></p>
        </div>
        <div class="main-item" >
          <p class="top">考试合格率 <img style="display: inline-block;float: right;" src="@/assets/img/ts5.png" alt=""></p>
          <p class="bottom">
            <span style="color:#AEDE67">{{form.exam_pass_rate }}</span>
            <span>%</span></p>
        </div>

      </div>
      <div class="deadline">统计数据截止时间：{{getCurrentTime()}}</div>
    </div>
    <div>
      <trainEchart  :id="'lineEchart'" v-if="echartData && echartData.x && echartData.x.length > 0" :ehartData="echartData" ></trainEchart>
    </div>
    <div class="wrap-bottom">
      <div class="search-block">
        <p class="block_title">人员统计信息</p>
        <div style="float: right">
        <el-input placeholder="请输入内容" size="mini" v-model="searchParams.keywords" class="search-input"></el-input>
          <el-select
              class="langInput"
              style="margin-right: 10px"
              v-model="searchParams.organization_id"
              filterable
              @clear="set_deepList('')"
              @change="set_deepList"
              size="mini"
              placeholder="请选择归属机构"
              clearable
          >
            <el-option
                v-for="item in orgList"
                :key="item.organization_id"
                :label="item.name"
                :value="item.organization_id"
            ></el-option>
          </el-select>
          <el-select
              class="langInput"
              v-model="searchParams.dept_id"
              size="mini"
              :disabled="deepList.length == 0 ? true : false"
              :placeholder="
                  deepList.length == 0 ? '请先选择机构或添加部门' : '请选择部门'
                "
              clearable
          >
            <el-option
                v-for="item in deepList"
                :key="item.pk"
                :label="item.name"
                :value="item.pk"
            ></el-option>
          </el-select>
        <el-button style="background-color: #4787F0;color:#fff;margin-left: 14px;" @click="handleSearch">搜索</el-button>
        <el-button style="background-color: #377F7F;color:#fff;" @click="handleExport">导出结果</el-button>
        <el-button @click="handleClearSearch" >重置</el-button>
        </div>
      </div>
      <div style="background-color: #fff;padding:16px;">
        <el-table
            :data="tableData" stripe
            max-height="450"
            style="width: 100%">
          <el-table-column type="index" label="#" width="50"></el-table-column>
          <el-table-column prop="account" label="人员姓名" min-width="100">
            <template v-slot="{row}">
              <el-button type="text" @click="handleExam(row)">{{row.user_name}}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="organization" label="所属部门" min-width="150"></el-table-column>
          <el-table-column prop="need_training_count" label="安排培训总次数" width="130"></el-table-column>
          <el-table-column prop="participated_training_count" label="实际参加培训次数" width="140"></el-table-column>
          <el-table-column prop="need_exam_count" label="安排考试总次数" width="130"></el-table-column>
          <el-table-column prop="participated_exam_count" label="实际参加考试总次数" width="160"></el-table-column>
          <el-table-column prop="pass_percent" label="考试通过率" width="100">
            <template v-slot="{row}">
              <span v-if="row.pass_percent">{{row.pass_percent}}%</span>
            </template>
          </el-table-column>
          <el-table-column prop="best_exam_score" label="考试最高分" width="100"></el-table-column>
          <el-table-column prop="best_exam_ranking" label="最佳排名" width="100"></el-table-column>
          <el-table-column prop="" label="操作" width="250" header-align="center">
            <template v-slot  ="{row}">
              <el-button  @click="handleTrain(row)" style="color:#4095E5;" type="text" size="small">培训记录</el-button>
              <el-button  @click="handleExam(row)" style="color:#BD3124" type="text" size="small">考试记录</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="width: 100%;text-align: right;padding: 12px 0 0 0">
          <el-button @click="handlePrePage">上一页</el-button>
          <span style="margin: 0 12px" >{{ searchParams.page}}/{{Math.ceil( count/10)}}</span>
          <el-button @click="handleNextPage" :disabled="searchParams.page == Math.ceil( count/10) ">下一页</el-button>
        </div>
      </div>

    </div>
    <div class="ranking_wrap">
      <div class="ranking_block">
        <p>参加培训次数排名（TOP10）</p>
        <div>
          <ul>
            <li v-for="(item,index) in trainList">
              <span class="index"
                    :style="index== 0 ?'background:#FCCA00;color:#fff;': index== 1 ?'background:#CECECE;color:#fff': index== 2 ? 'background:#CBA43F;color:#fff' : ''">{{index+1}}</span>
              <span class="name">{{item.user_name}}</span>
              <span class="times">{{item.training_count}}次</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="ranking_block">
        <p>参加考试次数排名（TOP10）</p>
        <div>
          <ul>
            <li v-for="(item,index) in examList">
              <span class="index"
                    :style="index== 0 ?'background:#FCCA00;color:#fff;': index== 1 ?'background:#CECECE;color:#fff': index== 2 ? 'background:#CBA43F;color:#fff' : ''">{{index+1}}</span>
              <span class="name">{{item.user_name}}</span>
              <span class="times">{{item.exam_count}}次</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="ranking_block">
        <p>通过率排名（TOP10）</p>
        <div>
          <ul>
            <li v-for="(item,index) in rateList">
              <span class="index"
                    :style="index== 0 ?'background:#FCCA00;color:#fff;': index== 1 ?'background:#CECECE;color:#fff': index== 2 ? 'background:#CBA43F;color:#fff' : ''">{{index+1}}</span>
              <span class="name">{{item.user_name}}</span>
              <span class="times">{{item.pass_rate}}%</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import trainEchart from "@/views/cloudTraining/statistics/components/trainEchart.vue";
import shouyeBarEchart from "@/components/shouyeBarEchart.vue";
import {getSummary, getTop10, monthlyStat, usersStat} from "@/api/training";
import api from '@/api/manage.js'
export default {
  components: {
    shouyeBarEchart,
    trainEchart
  },
  name: "examRecord",
  data() {
    return {
      current:1,
      count:1,
      searchParams:{
        keywords:'',
        organization_id:'',
        dept_id:'',
        page:1,
        size:10,
      },
      echartData: {},
      orgList: [],
      deepList:[],
      userData_param: {
        phone: '',
        passwd: '',
        user_name: '',
        dept_id: '',
        post_id: '',
        choice_gender: 1,
        role_id: '',
        login_platforms: ''
      },
      value: '',
      options: [],
      tableData: [],
      form:{},
      examList: [],
      trainList: [],
      rateList: [],
    }
  },
  created() {
    this.getYearData()
    this.getSummary()

    this.gerUsersStat()
    this.getTop10()
    this.get_system_org_all()
  },
  methods: {
    getSummary(){ //考试统计
      getSummary().then(res => {
        this.form = res.data
      })
    },
    getYearData(){ //近一年参与培训人数及通过考核人数趋势图
      monthlyStat().then(res=>{
        let resData = res.data
        this.echartData.x = resData.map(item=>{ return item.month + '月'})
        this.echartData.training = resData.map(item=>item.training_people)
        this.echartData.exam = resData.map(item=>item.exam_pass_people)
        this.echartData.rate = resData.map(item=>item.one_try_pass_rate)
      })
    },
    gerUsersStat(){ //人员统计信息
      usersStat(this.searchParams).then(res=>{
        this.tableData = res.data.results
        this.count = res.data.count
      })
    },
    getTop10(){ //top10
      getTop10().then(res=>{
        this.examList =res.data.exam_top10
        this.trainList =res.data.training_top10
        this.rateList =res.data.pass_rate_top10
      })
    },
    handleExam(row) {
      this.$router.push({path: '/cloudTraining/statistics/examRecord',query: {user_id: row.user_id,user_name:row.user_name }})
    },
    handleTrain(row){
      this.$router.push({path: '/cloudTraining/statistics/trainRecord',query: { user_id: row.user_id,user_name:row.user_name}})
    },
    getCurrentTime() {
      const now = new Date();
      const pad = n => String(n).padStart(2, '0');
      return `${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
    },
    handleSearch(){
      this.searchParams.page = 1
      this.gerUsersStat()
    },
    handlePrePage(){
      let pre =this.searchParams.page -1
      if(pre > 0){
        this.searchParams.page= this.searchParams.page - 1
        this.gerUsersStat()
      }
    },
    handleNextPage(){
      let next = this.searchParams.page -1

      if(next < this.count/10 ){
        this.searchParams.page = this.searchParams.page +1
        this.gerUsersStat()
      }
    },
    handleExport(){
      this.searchParams.export = 'True'
      usersStat(this.searchParams).then(res=>{
       this.downloadFile(res.data.file_url)
      })
    },
    downloadFile(url) {
      return new Promise((resolve, reject) => {
        const fileName = url.split('/').pop()
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.download = fileName
        // 这个延迟操作的目的是为了确保浏览器有足够的时间来处理下载操作
        // 这样可以避免在循环中快速触发多个下载操作，导致浏览器无法正确处理下载请求
        link.addEventListener('click', () => {
          setTimeout(() => {
            resolve()
          }, 1000)
        })
        link.click()
      }).finally(()=>{this.exporting = false})
    },
    handleClearSearch(){

      this.searchParams = {
        page:1
      }
    },
    // 获取系统管理组织机构架构列表全列表
    get_system_org_all() {
      this.treeLoading = true
      this.loadingShow('加载中')
      api
          .system_org({ size: 'all' })
          .then((res) => {
            this.orgList = res.data
            // this.filter_org()
            /* user页处理 */
            this.organizations = this.orgList
            // this.filter_org_tree()
            this.filter_org()

          })
          .finally((msg) => { this.treeLoading = false
            this.loading.close()})
    },
    // 根据确认的机构查询部门信息
    set_deepList(organization_id,dept_id='') {
      this.userData_param.dept_id = dept_id
      if(organization_id){
        this.userData_param.role_id = ''
        this.deepList = this.orgList.find((e) => e.organization_id == organization_id).children
      }else {
        this.deepList = [];
        this.searchParams.dept_id = ''
      }
    },
    // 提示弹窗
    loadingShow(text) {
      this.loading = this.$loading({
        lock: true,
        text,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
    },
  }
}
</script>


<style scoped lang="scss">
@import "@/assets/css/asset.scss";
.wrap {
  margin: 10px 20px;
  box-sizing: border-box;

  .wrap-top {
    display: inline-block;
    width: 100%;
    border-radius: 3px;
    background-color: #fff;
    padding: 20px 10px 14px 10px;
    box-sizing: border-box;
    .deadline{
      display: inline-block;
      width: 100%;
      color: #9A9A9A;
      text-align: right;
      padding: 20px 10px 0 0;
      box-sizing: border-box;
      font-size: px(13);
    }
    //display: flex;
    //justify-content: space-between;
    .top-main {
      width: 100%;
      display: flex;
      justify-content: space-around;

      box-sizing: border-box;

      .main-item {
        width: 18%;
        height: 100px;
        border-radius: 3px;
        padding: 12px 16px 16px 20px;
        box-sizing: border-box;
        border:1px solid #EFEFEF;
        p.top {
          color: #6C6C6C ;
          font-size: 16px;
          font-weight: bold;
        }

        p.bottom {
          margin-top: 18px;
          color: #6C6C6C;
          text-align: center;

          span:first-child {
            font-size: 28px;
          }
          span {
            font-size: 16px;
          }
        }
      }
    }
  }

  .wrap-bottom {
    .search-block {
      display: inline-block;
      width: 100%;
      padding: 20px;
      box-sizing: border-box;
      background-color: #fff;
      margin: 20px  0 0 0;

      .search-input {
        width: 300px;
        margin-right: 20px;

        ::v-deep input {
          width: 100%;
        }
      }
    }
  }
}

::v-deep .el-table thead tr th {
  background-color: #F2F2F2;
  color: #000;
}
.block_title{
  font-size: px(20);
  color:#000;
  display: inline-block;
  line-height: 40px;
  font-weight: bold;
}
.ranking_wrap{
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  .ranking_block{
    padding: 20px;
    width: 30%;
    background-color: #fff;
    border-radius: 5px;
    p{
      font-weight: bold;
      border-bottom: 1px solid #eee;
      padding-bottom: 10px;
      margin-bottom: 20px;

    }
    ul li{
      display: block;
      margin:7px 0;
      color:#6C6C6C;
      span.index{
        display: inline-block;
        border:1px solid #eee;
        border-radius: 50%;
        width:28px;
        height:28px;
        text-align: center;
        vertical-align: middle;
        line-height:28px;
        margin-right: 20px;
      }

      span.name{
        margin-left: 10px;
        font-size: 16px;
      }
      span.times{
        display: inline-block;
        float: right;
      }
    }
  }
}

</style>